// A company link is an internal destination only; never accept a URL or arbitrary route.
export function companyIdFromSearch(search) {
  const value = new URLSearchParams(search).get('company')
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value || '')
    ? value.toLowerCase()
    : null
}
